home_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large secondary-bg background-img');
        mapData.drawnItemsLayer.clearLayers();
        step_one_handler.showContent();

        $(document).off("click", ".like-btn");
        map.off('popupclose');
        map.off('popupopen');
        
        self.disableRouteEasyClick();


        self.updateLS();
        // self.loadData();

        if (typeof localStorage !== 'undefined') {
          var name = localStorage.getItem(
            'form-submitter-name'
          ) || undefined;
          var email = localStorage.getItem(
            'form-submitter-email'
          ) || undefined;
          if (typeof email !== 'undefined') {
            $('form#intro-form input[name=intro-email]').val(email);
          }

          if (typeof name !== 'undefined') {
            $('form#intro-form input[name=intro-name]').val(name);
          }
        }

        $('form#intro-form').submit(function(e){
            e.preventDefault();

            var name = $('form#intro-form input[name=intro-name]').val();
            var email = $('form#intro-form input[name=intro-email]').val();

            var formData = {
                'name': name,
                'email': email,
            }

            console.log(formData);

            if (typeof localStorage !== 'undefined') {
                localStorage.setItem(
                    'form-submitter-name',
                    formData.name
                )
                localStorage.setItem(
                    'form-submitter-email',
                    formData.email
                )
            }

            if (name && email) {
                $('.controls').show();
                window.location.hash = '#/goals/';
            }

            return false;
        });

    },

    scrollTop: function(){
        $('html, body').animate({ 
           scrollTop: 0}, 
           800, 
           "swing"
        );
    },

    scrollContent: function(){
        $('html, body').animate({ 
           scrollTop: $(window).height()/3}, 
           800, 
           "swing"
        );
    },

    scrollTo: function(divID){
        $('.child-content, html, body').animate({ 
           scrollTop: $('#'+divID).offset().top}, 
           800, 
           "swing"
        );
    },

    getRequest: function(){
        var self = this;
        var id = properties.loadHashID;

        if (mapData.features[id]){

            window.location.href = "#/project-view/" + id;

        }
    },

    //Update Local Storage
    updateLS: function(){
        try {
          mapData.pvlk =  JSON.parse( localStorage.getItem( 'pvlk-pbot' ) ) || {};
        }
        catch(e) {
          console.log(e);
        }
    },

    //Add to Local Storage
    addLS: function(id){
        var self = this;
        var pg = {};

        pg.ID = id || null;
        
        if (!mapData.pvlk){
          mapData.pvlk = {}
        }

        if (pg.ID){
          mapData.pvlk[pg.ID] = pg;
        }

        try {
          localStorage.setItem( 'pvlk-pbot', JSON.stringify(mapData.pvlk) );
        }
        catch(e) {
          return false;
        }
        self.updateLS();
        return true;
    },

    addLike: function(id, type){

        var self = this;
        var value = mapData.featuresData[id];

        $.ajax({
          type: "POST",
          url: mapData.likesURL,
          data: {
            'sid': id,
            'type': type
          },
          success: function(json) {
            value[type] = parseInt(value[type]) + 1;
            self.addLS(id);

            //Update popup content
            mapData.features[id]._popup.setContent(self.generatePopUp(value));
            //update view content
            view_handler.getLikes();

          },
          error: function(xhr, textStatus, errorThrown) {
            console.log(textStatus);
          }
        });
    },


    fixedComment: function(comment, category) {
        comment = comment.replace(/(<([^>]+)>)/gi, "");

        if ($.trim(comment).length == 0 && add_feature_handler.properties.selectCategories[category]) {
            comment = add_feature_handler.properties.selectCategories[category].title;
        }

        if ($.trim(comment).length == 0){
            return '<br>';
        }

        return '<br><div class="comment"><p>"' + comment + '"</p></div>';
    },

    fixedLikes: function(feature) {
        
        var likes = feature.like || 0;
        var dislikes = feature.dislike || 0;

        if (likes == 1) {
            likes = "1 Like";
        } else if (likes > 1 || likes == 0) {
            likes = likes + " Likes";
        }

        if (dislikes == 1) {
            dislikes = "1 Dislike";
        } else if (dislikes > 1 || dislikes == 0) {
            dislikes = dislikes + " Dislikes";
        }

        return likes + ' - ' + dislikes;

    },

    likeBtn: function(marker) {
        if (marker in mapData.pvlk){
          return '';
        }
        else {
          return '<button class="inline-block like-btn" type="like" marker="'+marker+'" >Like</button> <button class="inline-block like-btn" type="dislike" marker="'+marker+'" >Dislike</button> '
        }
    },

    commentBtn: function(marker) {
        return '<br><a class="inline-block btn-novel" href="#/view/'+marker+'" >View/Add Comment</a>';
    },

    grabDraw: function(){
        var layer = mapData.drawnItemsLayer.getLayers()[0];

        if (layer){
            var shape = layer.toGeoJSON();
            var shape_for_db = JSON.stringify(shape);
            return shape_for_db;
        }
        else {
            return false;
        }
    },

    checkInBounds: function(marker, poly) {

        var polyPoints = poly.getLatLngs()[0];

        var inside = false;
        var points;

        if (marker instanceof L.Marker) {
            points = [marker.getLatLng()];
        } else if (marker instanceof L.Path) {
            points = marker.getLatLngs();
        }

        $.each(points, function(index, value) {
            var x = value.lat;
            var y = value.lng;
            inside = false;
            for (var i = 0, j = polyPoints.length - 1; i < polyPoints.length; j = i++) {
                var xi = polyPoints[i].lat, yi = polyPoints[i].lng;
                var xj = polyPoints[j].lat, yj = polyPoints[j].lng;
                var intersect = yi > y != yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
                if (intersect){
                    inside = !inside;
                };

            }

            if (inside == false){
                return false;
            }

        });
        
        return inside;
    },

    onOutOfBounds: function(){
        $('#map').addClass('boundsError');

        var checked = $('.content-error').hasClass('bounceIn');

        if (checked){
            $('.content-error').removeClass('bounceIn').addClass('bounce');
        }
        else {
            $('.content-error').removeClass('hidden bounce').addClass('animated bounceIn');
        }


        mapData.geoJSON.cityBounds.setStyle({
            fillOpacity: 0,
            opacity: 1,
            weight: 5
        });
    },

    onInBounds: function(){
        $('#map').removeClass('boundsError');
        $('.content-error').addClass('hidden').removeClass('animated bounceIn');

        mapData.geoJSON.cityBounds.setStyle({
            fillOpacity: 0,
            opacity: 1,
            weight: 2
        });
    },

    centerDraw: function(layer){
        var self = this;
        invalidateMap();
        if (layer instanceof L.Marker || layer instanceof L.Circle) {
            
            var zoomLevel = (map.getZoom() >= 15) ? map.getZoom() : 15;
            var targetPoint = map.project(layer.getLatLng(), zoomLevel);
            var targetLatLng = map.unproject(targetPoint, zoomLevel);
            map.setView(targetLatLng, zoomLevel);
        }

        else if (layer instanceof L.Polyline) {

            map.fitBounds(layer.getBounds(), {
                padding: [20,20],
                maxZoom: 15,
            });
            // self.snapToRoad(layer);

        }

        else{
            map.fitBounds(layer.getBounds(), {
                padding: [20,20],
                maxZoom: 15,
            });
        }
        
    },

    onMarkerClick: function(marker){
        var _location = marker.getLatLng();
       
       function highlightSelected(){

           var circle = new L.Circle(_location, 35, {
                radius: 15,
                fillColor: "#ffe612",
                color: "#000",
                weight: 1,
                opacity: 0,
                fillOpacity: 0.8,
                clickable: false
            });

            mapData.selectLayer.addLayer(circle);
            // apparently this doesn't exist, but it does
            try  {
                mapData.selectLayer.bringToFront();
            } catch (e) {
                console.warn("We tried to do something with mapData.selectLayer but it didn't exist yet");
            }
            // marker.bringToFront();
       }

       setTimeout(highlightSelected, 50);
    },

    highlightPolyline: function(polyline){
        mapData.selectLayer.clearLayers();
        map.closePopup();

        var points = polyline.getLatLngs();
        var polylineSelect = new L.Polyline(points, {
            stroke: true,
            color: "#ffe612",
            weight: 15,
            opacity: 0.8,
            smoothFactor: 1,
            clickable: false
        });

        mapData.selectLayer.addLayer(polylineSelect);
        mapData.selectLayer.bringToFront();

        polylineSelect.bringToFront();
        polyline.bringToFront();

        $.each(mapData.geoJSONLayers, function(index, value) {
            mapData.geoJSONLayers[index].bringToFront();
        });

    },

    rollOverMarker: function(polyline){

        mapData.rollOverLayer.clearLayers();
        map.closePopup();
        var points = '';

        points = polyline.getLatLng();


        // TODO: 

        // if (polyline['_layers']) {
        //     var polylineLayers =  polyline.getLayers();
        //     $.each( polylineLayers, function( key, value ) {
        //         points = value.getLatLngs();
        //         var polylineSelect = new L.Polyline(points, {
        //             stroke: true,
        //             color: "#ffe612",
        //             weight: 15,
        //             opacity: 0.8,
        //             smoothFactor: 1,
        //             clickable: false
        //         });

        //         mapData.rollOverLayer.addLayer(polylineSelect);

        //     });
        //     // if (!L.Browser.ie){
        //     //     mapData.rollOverLayer.bringToFront();

        //     //     $.each( polylineLayers, function( key, value ) {
        //     //         value.bringToFront();
        //     //     });

        //     // }
            
        // }
        // else{
        //     var polylineSelect = new L.Polyline(points, {
        //         stroke: true,
        //         color: "#ffe612",
        //         weight: 15,
        //         opacity: 0.8,
        //         smoothFactor: 1,
        //         clickable: false
        //     });

        //     mapData.rollOverLayer.addLayer(polylineSelect);

        //     // if (!L.Browser.ie){
        //     //     mapData.rollOverLayer.bringToFront();
        //     //     polyline.bringToFront();
        //     // }
        // }
        
    },

    rollOverPolyline: function(polyline){

        mapData.rollOverLayer.clearLayers();
        map.closePopup();
        var points = '';
        // if (polyline.feature

        points = polyline.getLatLngs();

        if (polyline['_layers']){
            var polylineLayers =  polyline.getLayers();
            $.each( polylineLayers, function( key, value ) {
                points = value.getLatLngs();
                var polylineSelect = new L.Polyline(points, {
                    stroke: true,
                    color: "#ffe612",
                    weight: 15,
                    opacity: 0.8,
                    smoothFactor: 1,
                    clickable: false
                });

                mapData.rollOverLayer.addLayer(polylineSelect);

            });
            // if (!L.Browser.ie){
            //     mapData.rollOverLayer.bringToFront();

            //     $.each( polylineLayers, function( key, value ) {
            //         value.bringToFront();
            //     });

            // }
            
        }
        else{
            var polylineSelect = new L.Polyline(points, {
                stroke: true,
                color: "#ffe612",
                weight: 15,
                opacity: 0.8,
                smoothFactor: 1,
                clickable: false
            });

            mapData.rollOverLayer.addLayer(polylineSelect);

            // if (!L.Browser.ie){
            //     mapData.rollOverLayer.bringToFront();
            //     polyline.bringToFront();
            // }
        }
        
    },

    onPolylineClick: function(clickArea, polyline){
        var self = this;
        mapData.selectLayer.clearLayers();
        var points = '';

        function highlightSelected(){

            var polylineSelect = new L.Polyline(points, {
                stroke: true,
                color: "#ffe612",
                weight: 15,
                opacity: 0.8,
                smoothFactor: 1,
                clickable: false
            });

            mapData.selectLayer.addLayer(polylineSelect);
            try  {
                mapData.selectLayer.bringToFront();
            } catch (e) {
                console.warn("We tried to do something with mapData.selectLayer but it didn't exist yet");
            }
            polyline.bringToFront();
        }

        if (polyline['_layers']){
            var polylineLayers =  polyline.getLayers();
            $.each( polylineLayers, function( key, value ) {
                points = value.getLatLngs();
                var polylineSelect = new L.Polyline(points, {
                    stroke: true,
                    color: "#ffe612",
                    weight: 15,
                    opacity: 0.8,
                    smoothFactor: 1,
                    clickable: false
                });

                mapData.selectLayer.addLayer(polylineSelect);

            });

            mapData.selectLayer.bringToFront();

            $.each( polylineLayers, function( key, value ) {
                value.bringToFront();
            });


        } else {
            points = polyline.getLatLngs();


            if (clickArea !== undefined && (map.getZoom() > 13)){
                var layersWithin = L.GeometryUtil.layersWithin(map, mapData.lineStringLayer.getLayers(), clickArea, 20);

                setTimeout(highlightSelected, 50);

                if (layersWithin.length > 1){
                    mapData.nearbyRoutes = layersWithin;
                    window.location.href = "#/nearby";

                    if (properties.currentURL == 'nearby'){
                        nearby_handler.updateNearbyRoutes();
                    }


                }

                else if (layersWithin.length == 1){


                    if (properties.currentURL == 'nearby'){
                        $('#content-root, #map').removeClass('noswipe');
                        window.location.href = "#/" + properties.previousURL;
                    }


                }
            }
            else {
               setTimeout(highlightSelected, 50);

            }
        }
        

    },

    clearHighlights: function(){

        var selectLayer = mapData.selectLayer.getLayers();
        $.each( selectLayer, function( key, value ) {
            if (key == 0 || key < (selectLayer.length - 1)){
                mapData.selectLayer.removeLayer(value);
            }
        });

    },

    enableRouteEasyClick: function(){

        var self = this;

        map.on("click", function(e) {

            //Check to see if draw is enabled.
            var markerDrawActive = mapData.drawControl.marker['_enabled'] || undefined;
            var polylineDrawActive = mapData.drawControl.polyline['_enabled'] || undefined;

            var clickedArea = e.latlng;
            var closestLayer = L.GeometryUtil.closestLayer(map, mapData.geoJSONLayer.getLayers(), e.latlng);
            
            //If a close layer exists and draw is disabled, execute.
            if (closestLayer && markerDrawActive !== true && polylineDrawActive !== true) {
                if (closestLayer.distance <= 20){
                    var closest = L.GeometryUtil.closest(map, closestLayer.layer, e.latlng, false);
                    if (closest) {
                        var latlng = L.latLng(closest.lat, closest.lng);
                        self.onPolylineClick(latlng, closestLayer.layer);
                        closestLayer.layer.fireEvent('click');
                    }
                }
            }
        });

    },


    disableRouteEasyClick: function(){
        map.off("click");
    },

    generatePopUp: function(value){
        var self = this;
        return '<b>By: </b><span class="name">' + value.name + "</span>" + self.fixedComment(value.comment, value.category) + '<div class="likes">' + self.fixedLikes(value) + '</div>' + self.likeBtn(value.id) + self.commentBtn(value.id);
    },

    setData: function(){

        var self = this;

        $.each(mapData.featuresData, function(index, value) {

            //Point Items
            if (mapData.features[value.id] == undefined && value.type == 'Point') {
                var geometry = JSON.parse(value.geometry);

                mapData.features[value.id] = L.marker([ geometry[1], geometry[0] ], {
                    icon: new L.PointIcon({iconUrl: "img/legend/" + value.category + ".png"}),
                    category: value.category
                }).on('click', function(e) {
                    self.onMarkerClick(e.target);
                });

                mapData.features[value.id].bindPopup(self.generatePopUp(value));
                mapData.pointsLayer.addLayer(mapData.features[value.id]);
            }

            //Polyline Items
            else if (mapData.features[value.id] == undefined && value.type == 'LineString') {
                var geometry = JSON.parse(value.geometry);
                var pointList = [];

                $.each(geometry, function(index, value) {
                    var point = new L.LatLng(value[1], value[0]);
                    pointList.push(point);
                });

                var color = add_feature_handler.properties.selectCategories[value.category]?add_feature_handler.properties.selectCategories[value.category].color:'#000';

                mapData.features[value.id] = new L.Polyline(pointList, {
                    stroke: true,
                    color: color,
                    category: value.category,
                    weight: 4,
                    opacity: 1,
                    dashArray: "5,10",
                    smoothFactor: 1,
                    className: 'linePoints',
                    id: value.id
                }).on('click', function(e) {
                    self.onPolylineClick(e.latlng, e.target);
                });

                mapData.features[value.id].bindPopup(self.generatePopUp(value));
                mapData.lineStringLayer.addLayer(mapData.features[value.id]);
            }
        });

        if (properties.loadHash == 'project-view'){
            properties.loadHash = '';
            self.getRequest();
        }

    },

    loadData: function(){

        var self = this;

        $.ajax({
            type: "GET",
            url: mapData.featuresURL,
            cache: false,
            dataType: "json",
            success: function(json) {

                $.each(json, function(index, value) {
                    if (index != "error" && mapData.featuresData[value.id] == undefined) {
                        mapData.featuresData[value.id] = value;
                    }
                });
                if ($.isEmptyObject(mapData.featuresData)) {
                    console.log("No featuresData");
                } else {
                    self.setData();
                }

            },
            error: function(xhr, textStatus, errorThrown) {
            }
        });
    },


    events: function() {
        var self = this;
        self.onLoad();

        $(document).on("click", ".like-btn", function(event){
            var that = $(this);
            var id = that.attr('marker');
            var type = that.attr('type');
            self.addLike(id, type);
        });

        // map.on("popupopen", function() {
        //     self.clearHighlights();
        // });

        // map.on("popupclose", function() {
        //     self.clearHighlights();
        // });

        self.enableRouteEasyClick();

    }
}
